/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM } from 'src/util/bem';
import './stationInfo.less';
let bem = createBEM('station-info');
import ECharts from 'vue-echarts';
import Bus, { Events } from 'src/util/bus';
import EnumDeviceStatus from 'src/enums/enumDeviceStatus';
import RouteUtils from 'src/util/routeUtils';
import EnumStationType from 'src/enums/enumStationType';

@Component
export default class StationInfo extends Vue.Component<any> {
    @Prop({
        type: Number,
    })
    type!: number;

    statusMap: any = {};

    click(e) {
        RouteUtils.goTo(`/${EnumStationType.findId(this.type).getCode()}/detection/station/list`, {
            deviceStatus: EnumDeviceStatus.findName(e.name).getId(),
        });
    }

    mounted() {
        Bus.$on(Events.DeviceStatusReady, statusMap => {
            this.statusMap = statusMap;
        });
    }

    beforeDestroy() {
        Bus.$off(Events.DeviceStatusReady);
    }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')}>站点信息</div>
                <div class={bem('content')}>
                    <div class={bem('device-total')}>
                        设备总数：<span>{Object.values(this.statusMap).reduce((total, i) => (total as any) + i, 0)}</span>
                    </div>
                    <div class={bem('chart-wrapper')}>
                        <div>
                            {EnumDeviceStatus.getList().map(i => {
                                return (
                                    <div class={bem('item')}>
                                        <div class={bem('count')}>{this.statusMap[i.id]}</div>
                                        <div class={bem('img')}>
                                            <img src={require('../../../assets/images/mainPage-icon2.png')} />
                                        </div>
                                        <div class={bem('text')}>{i.name}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
